import nl from "../locales/nl.json";

export const translations = {
    nl,
};
